import React, { useContext, useEffect, useState } from 'react'
import { Create, CartePrepayee, tracks } from 'requests/transfer'
import UserContext from 'contexts/UserContext'
import RecapComponent from 'components/recapComponent'
import Operateur from './operateur'
import MontantPrepayee from './montantPrepayee'
import { TypeCartePrepayee } from 'types/carteprepayee'
import CartePrepayeeContext from 'contexts/catrePrepayeeContext'
import StepTransfert from 'components/stepTransfert'
import VolumePayment from './paiementCartePrepayee'
import FlecheRetour from '../../assets/arrow-back-navigation.svg'
import { useNavigate } from 'react-router-dom'

export default function RechargeCartePrepayee() {
  const nomstep = ['Opérateur', 'Montant', 'Paiement']
  const [numStep, setNumStep] = useState(0)
  const [codeOperateur, setCodeOperateur] = useState<string>('')
  const [products, setProduct] = useState<TypeCartePrepayee[]>([])

  const [loading, setLoading] = useState(false)
  const { user } = useContext(UserContext)

  const [operateur, setOperateur] = useState('')
  const [logoOperateur, setLogoOperateur] = useState('')
  

  const [provider, setProvider] = useState('')
  const [receiveValue, setReceiveValue] = useState('')
  const [totalWithFee, setTotalWithFee] = useState('')
  const [sendValue, setSendValue] = useState('')

  const navigation= useNavigate()
  const [clientSecret, setClientSecret] = useState('')
  const [rechargeId, setRechargeId] = useState('')
  const [reference, setReference] = useState('')
  const [trackId, setTrackId] = useState('')

  const id = user?.user?._id
  const token = user?.token?.accessToken
      
  const [indexCarte, setIndexCarte] = useState(-1)
  const {carte , setCarte}= useContext(CartePrepayeeContext)
 
// Affichage de la liste des cartes sélectionnées
  useEffect(() => {
    async function fetchData() {
    
      try {
        if (id && token){
        const response = await CartePrepayee(id, token, codeOperateur)
        if (response?.success === true && Array.isArray(response.products)) {
          setProduct(response.products)
          setLoading(true)
        }}
      } catch (error) {
        console.error(error)
      }
     
    }
    if (user) {
      fetchData()
    }
  }, [user, codeOperateur])


  //vider le context 
  useEffect(()=>{
    if(operateur !== carte?.provider){
      setCarte(null)
      setReceiveValue('')
      setSendValue('')
      setTotalWithFee('')
      setProvider('')
      setIndexCarte(-1)
     
    }
  },[operateur])

// Remplissage du contexte
  const handdleSelect =(item : TypeCartePrepayee, index: number)=>{
    setReceiveValue(item.receiveValue.toString())
    setSendValue(item.sendValue.toString())
    setTotalWithFee(item.totalWithFee.toString())
    setProvider(item.provider)
    setIndexCarte(index)
    setCarte({
     SkuCode: item.SkuCode,
     currency: item.currency,
     display: item.display,
     fees: item.fees,
     provider: item.provider,
     receiveValue: item.receiveValue,
     sendValue: item.sendValue,
     totalWithFee: item.totalWithFee,
    
    })
  }

  const FNPayer = async () => {

    const dataRecharge = {

      userId: id,
      SkuCode: carte?.SkuCode,
      provider: provider,
      sendValue: carte?.sendValue,
      currency: carte?.currency,
      receiveValue: carte?.receiveValue,
      fees: carte?.fees,
      platform: 'web',
      payValue: carte?.totalWithFee
    }
    try {
     
      const response = await Create (id, token, dataRecharge)

      
      if (response?.success === true) {
        setClientSecret(response?.client_secret)
        setRechargeId(response?.prepaidProduct_id)
        setReference(response.reference)
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
    setNumStep(2)
  }

  // const confirmPayment = async () => {
  //    const token = user?.token?.accessToken

  //   const body = {
  //     prepaidProduct_id: rechargeId,
  //     platform:"web",
  //     trackId: trackId,
  //   }
  //   try {
  //     const response = await PaymentConfirmedCarte(body, token)
  //     if (response?.success === true) {
  //       setVoucher(response?.voucher)
  //     } else {
  //       console.error('response failed', response)
  //       setIsError(true)

  //     }
  //     setLoading(true)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }


  const functionTracks = async (stepNumber: string) => {
   
    let dataTracks = {
      label: 'recharge',
      step: stepNumber,
      userId: id,
    }
    if (stepNumber !== '0') {
      const newDataTracks = {
        ...dataTracks,
        trackId: trackId,
      }
      dataTracks = newDataTracks
    }
    try {
      const response = await tracks(dataTracks)
      if (response?.success === true) {
        setTrackId(response?.trackId)
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    functionTracks('0')
  }, [])

  const handleSelectOperateur=(value:any)=>{
    setCodeOperateur(value.code)
    setOperateur(value.name)
    setLogoOperateur(value.logo)

  }

  return (
   <div className="flex w-full  ">
    <div className="flex flex-col px-[80px] 3xl:px-[20px] lg:px-[5px] w-[70%] 3xl:w-[60%] items-center justify-center xl:w-full lg:mt-[40px] sm:mt-[20px] mb-10">
      <div className='flex w-full items-center justify-between'>
            <button
                type="button"
                onClick={() => navigation('/')}
                className="hidden lg:block cursor-pointer"
                aria-label="Retour à la page précédente"
              >
                <img src={FlecheRetour} alt="" />
              </button>  
          <h1 className="h1 w-full">Nouvelle Recharge </h1>
      </div>
          <div className="flex justify-between  w-full">
            {nomstep.map((item, index) => (

              <StepTransfert
                key={index}
                nomStep={item}
                numStep={index + 1}
                isActive={index <= numStep}
                lastStep={index < 2 ? true : false}
                isComplete={numStep > index}
                setNumStep={setNumStep}
              />
            ))}

    
        </div>
        <h2 className=' text-[22px] sm:text-[20px] flex items-start w-full font-bold font-roboto text-[#5754E5]  mb-[20px]'>Rechargez une carte prépayée</h2>

        {numStep === 0 && (
          <Operateur
            //  setOperateur={(value: string) => setOperateur(value)}
             onChange={handleSelectOperateur}
              // (value: string) => setIsOperateur(value)}
             isOperateur={codeOperateur}
             onChangeStep={() => setNumStep(1)}
             functionTracks={functionTracks}
          />
       
        )}

        {numStep === 1 && (
        <MontantPrepayee 
          products={products}
          handdleSelect= {(item: TypeCartePrepayee, index: number) =>handdleSelect(item, index)}
          onBackChangeStep={() => setNumStep(0)}
          onChangeStep={FNPayer}
          indexCarte={indexCarte}
          operateur={operateur}
          logoOperateur={logoOperateur}

        />
        )}
     
        {numStep === 2 && (
          <VolumePayment
           amount={Number(totalWithFee)}
            reference={reference}
            merchantPaymentId={reference}
          />
        )}

          
      </div>
      <div className='fixed bottom-0 mb-[100px] right-0 xl:hidden'>
        <RecapComponent
          label2={'Opérateur'}
          label4='Montant à envoyer'
          label3='Montant à payer'
          label5={'Montant à Recevoir'}
          operateur={operateur}
          montantEur={sendValue}
          receiveValue={receiveValue}
          montantSend={ totalWithFee}
          devise={carte?.currency}

        />
      </div>
        
      </div>

  )
}
